import React, {ReactElement} from 'react';
import {MinusCircle, PlusCircle} from '@fo/root/designSystem/atoms/Icons';
import {IconSize} from '@fo/root/designSystem/atoms/Icons/IconWrapper';

interface Props {
  isOpen?: boolean;
}

function PlusMinusExpand({isOpen}: Props): ReactElement {
  if (isOpen) {
    return <MinusCircle size={IconSize.LARGE} testId="ui.icon.PlusMinusExpand" />;
  }

  return <PlusCircle size={IconSize.LARGE} testId="ui.icon.PlusMinusExpand" />;
}

export default PlusMinusExpand;
